/**
 * @typedef {('xs'|'-xs'|'sm'|'-sm'|'md'|'-md'|'lg'|'-lg'|'xl'|'-xl'|'xxl'|'-xxl'|'xxxl'|'-xxxl')} GAP_SIZES
 */
export const GAP_SIZES = {
  none: "none",
  xs: "4px",
  "-xs": "-4px",
  sm: "8px",
  "-sm": "-8px",
  md: "16px",
  "-md": "-16px",
  lg: "24px",
  "-lg": "-24px",
  xl: "32px",
  "-xl": "-32px",
  xxl: "40px",
  "-xxl": "-40px",
  xxxl: "56px",
  "-xxxl": "-56px"
};

/**
 * @typedef {('PHONE'|'TABLET'|'LAPTOP'|'DESKTOP'|'WIDE')} MEDIA
 * @prop {string} PHONE         - max-width = 425px
 * @prop {string} TABLET        - min-width greater 426px and max-width less 768px
 * @prop {string} LAPTOP        - min-width greater 769px and max-width less 1024px
 * @prop {string} DESKTOP       - min-width greater 1025px and max-width less 1440px
 * @prop {string} WIDE          - min-width greater 1441px
 */
export const MEDIA = {
  PHONE: "(max-width: 425px)",
  TABLET: "(min-width:426px) and (max-width: 768px)",
  LAPTOP: "(min-width:769px) and (max-width:1024px)",
  DESKTOP: "(min-width:1025px) and (max-width: 1440px)",
  WIDE: "(min-width:1441px)"
};
export const CSS_MEDIA = {
  PHONE: "(min-width: 0px) and (max-width:425px)",
  PHONE_AND_ABOVE: "(min-width:425px)",
  PHONE_AND_BELOW: "(max-width: 425px)",
  TABLET: "(min-width: 425px) and (max-width:768px)",
  TABLET_AND_ABOVE: "(min-width:425px)",
  TABLET_AND_BELOW: "(max-width:767px)",
  LAPTOP: "(min-width:768px) and (max-width:1024px)",
  LAPTOP_AND_ABOVE: "(min-width:768px)",
  LAPTOP_AND_BELOW: "(max-width:1023px)",
  DESKTOP: "(min-width: 1024px) and (max-width:1440px)",
  DESKTOP_AND_ABOVE: "(min-width:1024px)",
  DESKTOP_AND_BELOW: "(max-width:1439px)",
  WIDE: "(min-width: 1440px) and (max-width:2560px)",
  WIDE_AND_BELOW: "(max-width:2559px)",
  WIDE_AND_ABOVE: "(min-width:1440px)"
};
export const ALIGN = {
  center: "center",
  top: "start",
  bottom: "end",
  left: "start",
  right: "end",
  "space-between": "space-between",
  "space-around": "space-around",
  "space-evenly": "space-evenly"
};